import { SponsoredProductType } from 'features/products/types';
import { Product } from 'common/components/product-card/types';
import { getProductBelongFromSource } from 'common/utils/analytics';
import { analyticsUtils } from 'utils/analytics-utils';

export const ANALYTICS_ELEMENT_BLOCK = 'recommendedProducts / basket';
export const GA_REMOVE_FROM_COMPARISON_LIST_EVENT = 'GA:removeFromComparisonList';
export const GA_ADD_TO_COMPARISON_LIST_EVENT = 'GA:addToComparisonList';

type ComparisonListEventArgs = {
  isInComparison: boolean;
  elementBlock: string;
  product: Product;
  productPosition: number;
};

const getAnalyticsData = (elementBlock: string, product: Product) => {
  if (elementBlock === ANALYTICS_ELEMENT_BLOCK) {
    return {
      brand: product.brand ?? null,
      category: product.compareCategory?.name ?? null,
      division: null,
      elementBlock,
      isMonetization: (product as SponsoredProductType)?.monetization ?? null,
      productBelong: getProductBelongFromSource(product.source),
      productDiscount: product.price.discount_percent ?? null,
      productFamilyId: product.compareCategory?.familyId ?? null,
      productTag: null,
      subdivision: null,
    };
  }

  return {};
};

export const sendGAComparisonEvent = ({
  isInComparison,
  elementBlock,
  product,
  productPosition,
}: ComparisonListEventArgs) => {
  const analyticsDataByElementBlock = getAnalyticsData(elementBlock, product);
  const { productId, displayedName: productName } = product;

  analyticsUtils.sendEvent(
    isInComparison ? GA_REMOVE_FROM_COMPARISON_LIST_EVENT : GA_ADD_TO_COMPARISON_LIST_EVENT,
    {
      elementType: 'button',
      elementBlock: 'productList / Catalog',
      elementName: 'comparisonList',
      productName,
      productId,
      productPrice: product.price.main_price,
      productPrevPrice: product.price.previous_price ?? product.price.previous_price,
      productPosition,
      ...analyticsDataByElementBlock,
    },
  );
};
